// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"36e4b9a5","136":"f1f00739","245":"21d41acc","583":"2daa20f9","787":"c096999d","810":"82c13673","955":"61f9774a"}[chunkId] + ".chunk.js";
};